module.exports = __webpack_public_path__ + "img/2.f62d1574.jpg";